<template>
  <div class="bottomInfo">
    <!-- <div class="backtop" @click="backTopUp" v-if="btnFlag">
      <i class="el-icon-arrow-up" style="height: 20px;display: inline-block;width: 40px;"></i>
      <span>顶部</span>
    </div>   -->
    <!-- <div class="backtop" id="backTop" @click="backTopUp" v-if="btnFlag">
        <i :class="{ 'icon-arrow-up' : backtop }"></i>
    </div> -->
    <div class="bottomInfo-container">
      <div class="topBottom">
        <div class="topBottom-left">            
          <!-- <span @click="toLogin('http://sanxinbook.com/')">
              三新官网
          </span> -->
          <!-- <span>
              <a target="_blank"
              href="http://sanxinbook.com/sxportal/html/productAndService/service.html?gid=2018021011492300014">三新出版</a>
          </span> -->
          <!-- <span @click="toLogin('http://www.ytzhihui.com')">
             云田智慧
          </span> -->
          <!-- <span>
          
            <a target="_blank" href="/#/ProductGuancang">馆藏分析平台</a>
          </span> -->
          <!-- <span>
            <a target="_blank"
              href="http://sanxinbook.com/sxportal/html/productAndService/service.html?gid=2018021010232100019">教材配送</a>
          </span> -->
          <!-- <span>
           
            <a target="_blank" href="http://qk.cxznlibwx.com">期刊订购</a>
          </span> -->
          <!-- <span>
            <a target="_blank" href="https://sanxints.tmall.com">天猫店</a>
          </span> -->
          <!-- <span>
            <a target="_blank" href="https://mall.jd.com/index-123500.html">京东店</a>
          </span> -->
        </div>
        <!-- <div class="topBottom-right">
          <div @mouseenter="enter(1)" @mouseleave="leave">
            <img class="tiantianImgOne" src="../../assets/images/bottomOne.png" alt="">
            <span>田田网小程序</span>
            <img v-show="threePage.one" class="tiantianImg" src="../../assets/images/xiaochengxu.jpg" alt="">
          </div>
          <div @mouseenter="enter(2)" @mouseleave="leave">
            <img class="tiantianImgOne" src="../../assets/images/bottomTwo.png" alt="">
            <span>田田阅读App</span>
            <img v-show="threePage.two" class="tiantianImg" src="../../assets/images/tiantianyuedu.jpg" alt="">
          </div>
          <div @mouseenter="enter(3)" @mouseleave="leave">
            <img class="tiantianImgOne" src="../../assets/images/bottomThree.png" alt="">
            <span>三新文化公众号</span>
            <img v-show="threePage.three" class="tiantianImg" src="../../assets/images/gongzhonghao.png" alt="">
          </div>
        </div> -->
      </div>
      
      <!-- <div class="gw-link">
            <span>高校服务证明：</span>
            <a href="https://netpic.ytzhihui.com/pic/cbs/xue/贵州医科大学.png" target="_blank">贵州医科大学</a>
            <a href="https://netpic.ytzhihui.com/pic/cbs/xue/贵州大学.png" target="_blank">贵州大学</a>
            <a href="https://netpic.ytzhihui.com/pic/cbs/xue/贵州民族大学.png" target="_blank">贵州民族大学</a>
            <a href="https://netpic.ytzhihui.com/pic/cbs/xue/贵州警察学院.png" target="_blank">贵州警察学院</a>
            <a href="https://netpic.ytzhihui.com/pic/cbs/xue/贵阳人文科技学院.png" target="_blank">贵阳人文科技学院</a>
            <a href="https://netpic.ytzhihui.com/pic/cbs/xue/贵阳学院.png" target="_blank">贵阳学院</a>
            <a href="https://netpic.ytzhihui.com/pic/cbs/xue/铜仁学院.png" target="_blank">铜仁学院</a>
      </div> -->
      <!-- <div class="gw-link">
            <span>媒体支持：</span>
            <a href="http://dzzy.cbbr.com.cn/html/2020-09/08/node_55895.htm" target="_blank">中国出版传媒商报</a>
            <a href="https://www.chinaxwcb.com/" target="_blank">中国新闻出版广电报</a>
            <a href="https://mp.weixin.qq.com/s?__biz=MzU1NDQ4Njc2NA==&mid=2247500768&idx=2&sn=c938c6f1797e3850c84e41e5ae45f6e8&chksm=fbe05d63cc97d4754f02e245084ee97cae9ea03eebb56f572761740ee8df1728c8982335a9ea&mpshare=1&scene=1&srcid=091254eRVr1e0733YeJ3r53P&sharer_sharetime=1599878527775&sharer_shareid=96bad08d5b03cf77d93b5f60ccd9f1a8#rd" target="_blank">图书馆报</a>
      </div> -->
      <div class="lasetDivThree">
        <span>客服热线：027-51850968</span>&emsp;
        <!-- <span>商务合作：027-51850951</span>&emsp; -->
        <!-- <span>邮箱：kefu@ytzhihui.com</span>&emsp; -->
        <span>地址：武汉市东湖新技术开发区佛祖岭街道金培路2号</span>
      </div>
      <div class="lasetDivThree">Copyright 1998 - {{ year }} http://sanxinbook.com/. All Rights Reserved.</div>
      <div class="lasetDivThree">湖北三新文化传媒有限公司 版权所有 <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" style="color:#999;text-decoration:none;">鄂ICP备13015831号-1</a></div>
    </div>

    <div>  
      <el-dialog
        style="z-index: 100000;"
        :visible.sync="erweima"
        width="20%"
        :show-footer="false"
        class="centered-dialog">
        <div style="display:flex ; justify-content: center; align-items: center; flex-direction: column; width: 100%; height: 100%;">
        <img alt="example" style="width: 225px; height: 225px;" src="../../assets/images/gh_9466731f8652_258 (1).jpg" />
        <div style="font-size:18px; margin-top: 15px;font-family: serif;">微信扫描二维码</div>
        </div>
      </el-dialog>
      <el-dialog
        style="z-index: 100000;"
        :visible.sync="contactusphone"
        width="20%"
        :show-footer="false"
        class="centered-dialog">
        <div style="display:flex ; justify-content: center; align-items: center; flex-direction: column; width: 100%; height: 100%;">
        <div style="font-size: 20px;">027-51850968</div>
        <div style="font-size:18px; margin-top: 15px;">客服热线</div>
        </div>
      </el-dialog> 
    </div>
    <div class="sidenavigationbar">
      <!-- <div class="sidenavigationbaritem"   @click="zhongjiangjilu()" v-if="(adminState==0 || adminState==1) && logintype == 0"  >
        <img style="width:50px; height: 50px;" title="" src="../../assets/ggw_img/xiaoshubao1122.png" alt="">
        <span style="display: block;font-family:'Alimama';">中奖记录</span>
      </div> -->
      <!-- <div class="sidenavigationbaritem"   @click="mycardcollecting()" v-if="adminState==1 && logintype == 0" >
        <img style="width:50px; height: 50px;" title="" src="../../assets/fonts/kabao.png" alt="">
        <span style="display: block;font-family:'Alimama';">我的集卡</span>
      </div> -->
      <div class="sidenavigationbaritem"  @click="toyuntiangou()" v-if="logintype==0" >
        <img style="width:50px" src="../../assets/images/shuxiang.png" alt="">
        <span style="display: block;font-family:'Alimama'">云田购</span>
      </div>
      <div class="sidenavigationbaritem"  @click="toyuntiangou1()" v-if="logintype==1"  >
        <img style="width:50px" src="../../assets/ggw_img/lunbo-2026-3-new1.png" alt="">
        <span style="display: block;font-family:'Alimama'">线上图采会</span>
      </div>
      <div class="sidenavigationbaritem"  @click="noBookRmd()" >
        <img style="width:50px" src="../../assets/images/nobooklist.png" alt="">
          <span style="display: block;font-family:'Alimama'">无书目荐购</span>
    </div>
      <div class="sidenavigationbaritem"  @click="showerweima()" >
          <img style="width:50px" src="../../assets/images/erwe2.png" alt="">
            <span style="display: block;font-family:'Alimama'">移动端选书</span>
      </div>
      <div class="sidenavigationbaritem"  @click="contactus()" >
        <img style="width:50px" src="../../assets/images/5e9f2b1b0da09ac3b3961378284ef2d4.png" alt="">
          <span style="display: block;font-family:'Alimama'">联系我们</span>
    </div>
    <div class="sidenavigationbaritem"   @click="ProblemReport()" >
        <img style="width:50px; height: 50px;" title="问题反馈" src="../../assets/images/fankui.jpg" alt="">
        <span style="display: block;font-family:'Alimama';">问题反馈</span>
    </div>
    <div class="sidenavigationbaritem"  id="backTop" @click="backTopUp" v-if="btnFlag" >
      <img style="width:40px; height: 40px;" title="回到顶部" src="../../assets/images/totop.png" alt="">
      <span style="display: block;font-family:'Alimama';">回到顶部</span>
  </div>
    </div>




  </div>
</template>

<script>
  import Cookies from 'js-cookie'
  import popup from "../../common/plugin/dialog/index";
  import addNobook from '../Xtch/noBooklist/addBook.vue'

  export default {
    // props: ['isLoginPage', 'datalogintype'],
    props: {
    isLoginPage: {
      type: Boolean,
      default: false
    },
    datalogintype:{
      type: String,
      default:''
    },
  },
    name: 'BottomComponent',
    computed: {
  },
    data() {  
      return {
        erweima: false,  
        contactusphone:false,
        threePage: {
          one: false,
          two: false,
          three: false,
        },
        logintype:Cookies.get('logintype'),        
        scrollTop:0,
        btnFlag:false,
        backtop: false,
        adminState: Cookies.get("adminState"),
        year: (new Date()).getFullYear()
      }
    },
    created(){
      this.logintype = this.datalogintype
    },
    mounted(){  
      this.logintype = Cookies.get('logintype')
      
      window.addEventListener('scroll', this.scrollToTop);
    },
    destroyed () {
      window.removeEventListener('scroll', this.scrollToTop);
    },
    methods: {
        //无书目荐购
        noBookRmd(){
            let vm = this;                
            vm.addnobook = popup('<add-nobook @ok="submit" :type="type"  @close ="close"></add-nobook>', {
                option: {
                    title: '无书目荐购',
                    width: "490px",
                },
                popup: {
                    data() {
                        return {
                          type:0
                        }
                    },
                    components: {
                        addNobook,
                    },
                    methods: {
                        submit(data) {
                            vm.addnobook.hide();                                
                        },
                        close(data) {
                            vm.addnobook.hide();
                        },
                    },
                },
            });
            vm.addnobook.show();
        },
         // 中奖记录
         zhongjiangjilu(){
            if (Cookies.get('token')) {
                const { href } = this.$router.resolve({
                  name: 'myPrice',
               });
            window.open(href, '_blank');
              } else {
                  this.$router.push({ name: 'Login' });
              }
        },
         // 我的集卡
         mycardcollecting(){
            if (Cookies.get('token')) {
                const { href } = this.$router.resolve({
                  name: 'mycardcollecting',
               });
            window.open(href, '_blank');
              } else {
                  this.$router.push({ name: 'Login' });
              }
        },
       //客户问题反馈
       ProblemReport() {
            if (Cookies.get("token")) {
                const { href } = this.$router.resolve({
                  name: 'ProblemReport',
               });
                window.open(href, '_blank');
            } else {
                this.$router.push({ name: "Login" });
            }
        },
      showerweima(file){
            this.erweima = !this.erweima
        }, 
        toyuntiangou(){
          const user = JSON.parse(localStorage.getItem('user'));
          this.$confirm("请确认是否关闭当前页面，前往荐购", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
        }).then(() => {
          if(user){
            Cookies.set('logintype',1)
         this.$router.push({ name: "Xindex",query:{ key:1 }  },)   
          }else{
            this.$router.push({ name: "Login" });
          } 
        }).catch(() => {
        });      
        } ,
        toyuntiangou1(){
          const user = JSON.parse(localStorage.getItem('user'));
          this.$confirm("请确认是否关闭当前页面，前往会场采购", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          if(user){
            Cookies.set('logintype',0)
            this.$router.push({ name: "HomePage"},)
          }else{
            this.$router.push({ name: "Login" });
          }
        }).catch(() => {
        });  
        } ,
      contactus(){
        this.contactusphone = !this.contactusphone
      },
      toLogin(url){
        if(Cookies.get('passPort')){
          window.open(`${url}?passPort=${Cookies.get('passPort')}`);
        }else{
           window.open(url)
        }
      },
      // 馆藏分析
      GuanZangClick(){
        this.$router.push({ name: "ProductGuancang" })
      },
      // 期刊订购
      QiKanClick() {
        this.$router.push({ name: "ProductQiKan" })
      },
      enter(index) {
        // this.leave()
        // console.log(index)
        this.threePage.one = index === 1 ? true : false
        this.threePage.two = index === 2 ? true : false
        this.threePage.three = index === 3 ? true : false
      },
      leave() {
        this.threePage.one = false
        this.threePage.two = false
        this.threePage.three = false
      },
      backTopUp() {
        let vm  = this;
        vm.backtop = true;
        let timer = setInterval(() => {
          let ispeed = Math.floor(-vm.scrollTop / 5)
          document.documentElement.scrollTop = document.body.scrollTop = vm.scrollTop + ispeed
          if (vm .scrollTop === 0) {
            clearInterval(timer)
          }
        }, 20);
      },
      scrollToTop () {
        const vm = this
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        vm.scrollTop = scrollTop;
        if (vm.scrollTop > 500) {
          vm.btnFlag = true;
        } else {
          vm.btnFlag = false;
            vm.backtop = false;
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .backtop{
    position: fixed;
    right: 50px;
    bottom: 50px;
    z-index: 9999;
    text-align: center;
    line-height: 20px;
    padding: 0px 8px;
    font-size: 16px;
    color: #999;
    cursor: pointer;
    >i{
        display: block;
        width:125px;
        height:126px;
        background: url(../../assets/images/long.png) no-repeat center center;
        background-size: 100%;
    }
    >i.icon-arrow-up{
        background: url(../../assets/images/long.png) no-repeat center center;
        
        background-size: 100%;
    }
  }
  .bottomInfo {
    padding: 10px 0px;
    width: 100%;
    line-height: 30px;
    font-size: 0px;
    background-color: white;
    margin-top: 30px;
  }

  /* 1 */
  .topBottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .topBottom-left {
    color: rgba(51, 51, 51, 1);
    font-size: 12px;
    text-align: left;
    font-family: PingFangSC-Regular;
  }

  .topBottom-left>span {
    padding: 0px 10px 0px 0px;
    cursor: pointer;
  }

  .topBottom-left>span:not(:first-child) {
    padding: 0px 10px 0px 10px;
  }

  .topBottom-left>span:not(:last-child) {
    border-right: 1px solid rgba(153, 153, 153, 1);
  }

  .topBottom-left a {
    text-decoration: none;
    color: rgba(51, 51, 51, 1);
  }

  .topBottom-right {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .topBottom-right>div {
    margin-left: 20px;
    display: flex;
    align-items: center;
    position: relative;
  }

  .tiantianImg {
    position: absolute;
    top: -100px;
    width: 80px;
  }

  .tiantianImgOne {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }

  .topBottom-right>div>span {
    color: rgba(153, 153, 153, 1);
    font-size: 12px;
    text-align: left;
    font-family: PingFangSC-Regular;
  }

  .bottomInfo-container {
    width: 1200px;
    margin: 0px auto;
    font-size: 14px;
  }

  .lasetDivThree {
    color: rgba(153, 153, 153, 1);
    font-size: 12px;
    text-align: left;
    font-family: PingFangSC-Regular;
  }
  .gw-link, .gw-link a{
      font-size:12px;
    color: rgba(153, 153, 153, 1);
    margin-right:10px;
    text-decoration: none;
  }
  .gw-link a:hover{
      color:red;
  }
  .sidenavigationbar{
        background-color:#fff;
        position: fixed;
        top: 26%; 
        right: 0px; 
        justify-content: center;
        width: 90px;
        /* height: 360px; */
    }
    .sidenavigationbaritem{
        display: flex; 
        align-items: center;
        flex-direction: column; 
        justify-content: center;
        border-top: 1px solid #dcdcdc ;
        border-left: 1px solid #dcdcdc ;
        border-bottom: 1px solid #dcdcdc ;
        border-right: 1px solid #ffe6e6;
        cursor: pointer;
        width: 100%;
        height: 80px;
        font-size: 14px;

    }
    .sidenavigationbaritem:hover{
      color: #ca1a1b;
    }
</style>



// WEBPACK FOOTER //
// src/views/Components/BottomComponent.vue